import Vue from "vue";
import VueRouter from "vue-router";

// Front End
import A005 from "../views/fe/A005.vue";
import A008 from "../views/fe/A008.vue";
import A008Category from "../views/fe/A008Category.vue";
import A010 from "../views/fe/A010.vue";
import A020 from "../views/fe/A020.vue";
import A025 from "../views/fe/A025.vue";
import A030 from "../views/fe/A030.vue";
import A035_040 from "../views/fe/A035_040.vue";
import A045_050 from "../views/fe/A045_050.vue";
import A055 from "../views/fe/A055.vue";
import A060 from "../views/fe/A060.vue";
import A065 from "../views/fe/A065.vue";
import A070 from "../views/fe/A070.vue";
import A075 from "../views/fe/A075.vue";
import A080 from "../views/fe/A080.vue";
import A085 from "../views/fe/A085.vue";
import A090 from "../views/fe/A090.vue";
import A095 from "../views/fe/A095.vue";
import A110 from "../views/fe/A110.vue";
import A015 from "../views/fe/A015.vue";
import A115 from "../views/fe/A115.vue";
import A120 from "../views/fe/A120.vue";
import A125 from "../views/fe/A125.vue";
import A130 from "../views/fe/A130.vue";
import Test from "../views/fe/Test.vue";

import ModalA040 from "../views/fe/ModalA040.vue";
import ModalA045 from "../views/fe/ModalA045.vue";

import A115Api from "../views/fe/A115Api.vue";
Vue.use(VueRouter);

const routes = [
  // Front End
  {
    path: "/",
    name: "a005",
    meta: { layout: "default", title: "front_end.common.default_title" },
    component: A005,
    children: [
      {
        path: "re-order",
        name: "a095",
        component: A095,
        meta: { title: "front_end.common.page_name_first" },
      },
    ],
  },
  {
    path: "/categories",
    name: "a008",
    alias: "/a008",
    meta: {
      layout: "default",
      title: "front_end.a008.title",
      back: "a005",
    },
    component: A008,
  },
  {
    path: "/categories/:definision",
    name: "a008_category",
    meta: {
      layout: "default",
      title: "front_end.a008.title",
      back: "a008",
    },
    component: A008Category,
  },
  {
    path: "/templates",
    name: "a010",
    alias: "/a010",
    meta: {
      layout: "default",
      title: "front_end.a010.title",
      back: "a008_category",
    },
    component: A010,
    children: [
      {
        path: "detail",
        name: "a015",
        component: A015,
      },
    ],
  },
  {
    path: "/a020/:templateId?",
    name: "a020",
    meta: {
      layout: "default",
      title: "front_end.a020.title",
      back: "a010",
    },
    component: A020,
  },
  {
    path: "/preview",
    name: "a025",
    alias: "/a025",
    meta: {
      layout: "default",
      title: "front_end.a025.title",
      back: "inactive",
    },
    component: A025,
  },
  {
    path: "/term-condition/:back?",
    name: "a030",
    alias: "/a030/:back?",
    meta: {
      layout: "default",
      title: "front_end.a030.title",
    },
    component: A030,
  },
  {
    path: "/user-info-order/:hash?",
    name: "a035",
    alias: "/a035",
    meta: {
      layout: "default",
      title: "front_end.a035.title"
    },
    component: A035_040,
    children: [
      {
        path: "register-address-receiver",
        name: "a040",
        meta: {
          title: "front_end.a035.title",
        },
        component: ModalA040,
      },
      {
        path: "bring-in",
        name: "a045",
        component: ModalA045,
      },
    ],
  },
  {
    path: "/register-address-receiver/:orderNo?",
    name: "a050",
    alias: "/a050",
    meta: {
      layout: "default",
      title: "front_end.a050.title",
    },
    component: A045_050,
  },
  {
    path: "/to-address-input",
    name: "a055",
    alias: "/a055",
    meta: {
      layout: "default",
      title: "front_end.a055.title",
      back: "a050",
    },
    component: A055,
  },
  {
    path: "/confirm-postcard",
    name: "a060",
    alias: "/a060",
    meta: {
      layout: "default",
      title: "front_end.a060.title",
    },
    component: A060,
  },
  {
    path: "/shop-payment/:orderNo?",
    name: "a065",
    alias: "/a065",
    meta: {
      layout: "default",
      title: "front_end.a065.title",
      back: "a060",
    },
    component: A065,
  },
  {
    path: "/edit-user-info-order",
    name: "a070",
    alias: "/a070",
    meta: {
      layout: "default",
      title: "front_end.a070.title",
    },
    component: A070,
  },
  {
    path: "/a075",
    name: "a075",
    meta: {
      layout: "default",
      title: "front_end.a075.title",
    },
    component: A075,
  },
  {
    path: "/complete-web/:orderNo?",
    name: "a080",
    alias: "/a080/:orderNo?",
    meta: {
      layout: "default",
      title: "front_end.a080.title",
      hideBack: true,
    },
    component: A080,
  },
  {
    path: "/complete-shop/:orderNo?",
    name: "a085",
    alias: "/a085/:orderNo?",
    meta: {
      layout: "default",
      title: "front_end.a080.title_shop",
      hideBack: true,
    },
    component: A085,
  },
  {
    path: "/complete-abnormal/:orderNo?",
    name: "a090",
    alias: "/a090/:orderNo?",
    meta: {
      layout: "default",
      title: "front_end.a090.title",
      hideBack: true,
    },
    component: A090,
  },
  {
    path: "/confirm-image/:orderNo?",
    name: "a110",
    alias: "/a110/:orderNo?",
    meta: {
      layout: "default",
      title: "front_end.a110.header_title",
      back: "a005",
    },
    component: A110,
  },
  {
    path: "/confirm-order-cod",
    name: "a115",
    alias: "/a115",
    meta: {
      layout: "default",
      title: "front_end.a115.header_title",
    },
    component: A115,
  },
  {
    path: "/complete-cod/:orderNo",
    name: "a120",
    alias: "/a120",
    meta: {
      layout: "default",
      title: "front_end.a120.header_title",
      hideBack: true,
    },
    component: A120,
  },
  {
    path: "/select-payment-method",
    name: "a125",
    alias: "/a125",
    meta: {
      layout: "default",
      title: "front_end.a125.header_title",
      back: "a060",
    },
    component: A125,
  },
  {
    path: "/accountReceiver/:orderNo?",
    name: "a130",
    alias: "/a130",
    meta: {
      layout: "default",
      title: "front_end.a130.header_title",
      back: "a125",
    },
    component: A130,
  },
  {
    path: "/testIE",
    name: "testIE",
    component: Test,
  },
  {
    path: "/error",
    name: "999",
    component: () =>
      import(/* webpackChunkName: "error" */ "../views/Error.vue"),
  },

  {
    path: "/cod",
    name: "a115",
    alias: "/a115",
    meta: {
      layout: "default",
      title: "front_end.a115.header_title",
      back: "a065",
    },
    component: A115Api,
  },
];
//empty
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
